import React, { useState, useEffect } from "react";
import { HelmetProvider } from "react-helmet-async";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Loader from "./components/Loader";
import Home from "./pages/Home";
import Contact from "./pages/Contact";
import Realisations from "./pages/Realisations";
import Services from "./pages/Services";
import Faq from "./pages/Faq";
import ScrollToTop from "./components/ScrollToTop";
import Mentions from "./pages/Mentions";
import Confidentialite from "./pages/Confidentialite";

function App() {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 1200);
    return () => clearTimeout(timer);
  }, []);

  if (loading) return <Loader />;

  return (
    <HelmetProvider>
      <BrowserRouter basename="/">
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/home" element={<Home />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/realisations" element={<Realisations />} />
          <Route path="/services" element={<Services />} />
          <Route path="/faq" element={<Faq />} />
          <Route path="/mentions-legales" element={<Mentions />} />
          <Route
            path="/politique-de-confidentialite"
            element={<Confidentialite />}
          />
        </Routes>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
